import { Controller } from "react-hook-form";
import { useEffect, useState } from "react";
import EditImagePopup from "../surety/common/popups/EditImagePopup";
import UploaderComponent from "../elements/UploaderComponent";







const UploadImageWithTools = ({ setValue, name, minWidthCrop, mainLabel, control, errors, imageData, setImageData, setsendImageToApi, isImageLoading }: any) => {

    const [popup, setPopup] = useState<boolean>(false);
    const [selectedImage, setSelectedImage] = useState<string | undefined>(undefined);

    const onClose = (action?: string) => {
        if (action === 'justClose')
            setPopup(false);
        else {
            setSelectedImage(undefined);
            setPopup(false)
        }
    }


    return (
        <div className="">
                <div className="flex flex-col gap-2">

                    <label className="text-Body-OneLine/14/Regular">
                        {mainLabel}
                        <span className="text-red-500">*</span>
                    </label>
                    <Controller
                        control={control}
                        name={name}
                        rules={{ required: true }}
                        render={({ field }) => {
                            return (
                                <UploaderComponent
                                selectedImage={selectedImage}
                                setSelectedImage={setSelectedImage}
                                    errors={errors.id_card}
                                    onChange={(file: any) => {
                                        field.onChange(file);
                                        setSelectedImage(file);
                                        setPopup(true);
                                    }}
                                    defaultValue={imageData ? imageData : null}
                                    onRemove={() => {
                                        field.onChange(null);
                                        setImageData(null);
                                        setsendImageToApi(true);
                                    }}
                                    isLoading={isImageLoading}
                                />
                            );
                        }}
                    />
                </div>
            {selectedImage && popup ? (<EditImagePopup name={name} minWidthCrop={minWidthCrop} setValue={setValue} handleChequeImageChange={setSelectedImage} onClose={onClose} setSelectedImage={setImageData} isFile imageData={selectedImage} />) : null}
        </div>
    )

}

export default UploadImageWithTools;
